<template>
	<div class="question">
		<div class="question_wrap">
			<a href="javascript:;" class="question_close" @click="onClose"></a>
			<div class="question_content">
				<div class="question_title">
					<div class="question_title_left"></div>
					<div class="question_title_msg">常见问题</div>
					<div class="question_title_right"></div>
				</div>
				<div class="question_item_wrap">
					<div class="question_item_title">下载的文件保存在哪里</div>
					<p>
						群晖：File Station/OWDownload；
						<br />海康：文件/下载/OWDownload；
						<br />联想：三方应用/玩物下载；
						<br />QNAP：Public/OWDownload。
						<br />由于NAS设备安全限制，玩物下载不能随意修改下载路径。
						<br />群晖可以通过以下方式修改下载磁盘：控制面板>>共享文
						<br />件夹>>选中OWDownload>>点击编辑>>选择“所在位
						<br />置”切换下载磁盘
						<br />
					</p>
					<div class="question_item_title">下载任务提示非法资源、版权问题</div>
					<p>
						玩物科技严格遵守国家的法律法规，对于涉及盗版、黄色、
						<br />反动等内容违规的资源，依据国家相关部门的规定，不予
						<br />支持下载，敬请谅解。
					</p>
					<div class="question_item_title">任务下载不动</div>
					<p>
						一般没有速度的任务都是由于资源当前太冷门造成，建议您
						<br />更换下载链接尝试重新下载。。
					</p>
					<div class="question_item_title">下载失败</div>
					<p>
						如果任务长时间找不到可下载的站点，或者BT任务中某些
						<br />子文件非法，会导致下载失败，但已下载的文件不影响您
						<br />使用。您可以更换下载链接重新下载该资源。
					</p>
					<div class="question_item_title">创建、暂停、开启、删除任务失败</div>
					<p>1 请检查设备联网是否正常</p>
					<p>2 请重启您的设备</p>
					<p>3 更新玩物下载插件到最新版本</p>
					<div class="question_item_title">如何解绑设备/绑定其他设备</div>
					<p>
						玩物下载目前仅支持设备和微信一对一绑定，您可通过以下
						<br />方法解除绑定：使用已绑定的微信，在【玩物下载】公众号
						<br />发送“解绑”，按照公众号指引完成解绑。
					</p>
				</div>
				<div class="question_bottom">
					<div>如果您仍有问题没解决，欢迎扫码咨询客服，谢谢。</div>
					<div>
						<img src="../assets/owdl_qrcode.jpg" alt />
						<p>客服中心</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onClose: function () {
			let _that = this;
			_that.$store.state.isShowQuestions = false;
		},
	},
};
</script>

<style lang="less" scoped>
.question {
	position: absolute;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 10;
	.question_wrap {
		width: 430px;
		height: 640px;
		background-color: #3867ac;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -215px;
		margin-top: -320px;
		border-radius: 8px;

		.question_close {
			position: absolute;
			top: 15px;
			right: 15px;
			width: 20px;
			height: 20px;
			background-image: url(../assets/alert_close_btn.png);
			background-repeat: no-repeat;
			background-size: 15px 15px;
			display: block;
		}
		.question_content {
			background-color: #f6fbff;
			width: 410px;
			height: 620px;
			margin: 0 auto;
			margin-top: 10px;
			border-radius: 6px;
			padding-top: 1px;
			.question_title {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 90%;
				margin: 30px auto 0;
				padding-bottom: 7px;
				border-bottom: 1px solid rgba(176, 176, 176, 0.3);
				.question_title_left {
					width: 14px;
					height: 14px;
					background-image: url(../assets/questions_top_icon.png);
					background-size: 100% 100%;
					background-repeat: no-repeat;
					background-position: center;
				}
				.question_title_msg {
					color: #707070;
					font-size: 22px;
					font-weight: bold;
					margin-left: 8px;
					margin-right: 8px;
				}
				.question_title_right {
					width: 14px;
					height: 14px;
					background-image: url(../assets/questions_top_icon.png);
					background-size: 100% 100%;
					background-repeat: no-repeat;
					background-position: center;
					transform: rotateY(180deg);
				}
			}
			.question_item_wrap {
				max-height: 405px;
				overflow-y: scroll;
				font-size: 14px;
				// margin: 0 auto;
				// width: 90%;
				margin-left: 5%;

				.question_item_title {
					color: #707070;
					margin-top: 18px;
					margin-bottom: 8px;
					font-weight: bold;
					padding-left: 10px;
					background-image: url(../assets/title_icon.png);
					background-size: 6px 16px;
					background-repeat: no-repeat;
					background-position: left center;
				}
				p {
					color: #949494;
					line-height: 22px;
				}
			}
			.question_bottom {
				border-top: 1px solid rgba(176, 176, 176, 0.3);
				width: 90%;
				margin: 0 auto;
				div:nth-child(1) {
					color: #707070;
					font-size: 14px;
					margin-top: 15px;
				}
				div:nth-child(2) {
					text-align: center;
					img {
						width: 76px;
						height: 76px;
					}
					p {
						color: #999999;
						font-size: 12px;
					}
				}
			}
		}
	}
}
</style>